import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { Clock, ArrowRight, Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Property } from "@/pages/Properties";
import PropertyCard from "@/components/PropertyCard";
import { useLocaleNavigate } from "@/hooks/useLocaleNavigate";

const FeaturedDeals = () => {
  const { t } = useLanguage();
  const navigate = useLocaleNavigate();
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLatest = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from("properties_view_2")
        .select("*")
        .eq("type", "Апартаменти")
        .order("updated_at", { ascending: false })
        .limit(4);

      if (!error && data) {
        setProperties(data as Property[]);
      }
      setLoading(false);
    };
    fetchLatest();
  }, []);

  return (
    <section id="deals" className="py-16 lg:py-20 bg-[hsl(210,20%,98%)]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
            {t.featuredDeals.title}
          </h2>
          <p className="text-muted-foreground">
            {t.featuredDeals.subtitle}
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {properties.map((property, index) => (
                <div
                  key={property.id}
                  className="animate-fade-in"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <PropertyCard property={property} />
                </div>
              ))}
            </div>
            <div className="text-center mt-8">
              <Button variant="outline" className="rounded-full gap-1.5" onClick={() => navigate("/properties")}>
                {t.featuredDeals.viewAll}
                <ArrowRight className="h-4 w-4" />
              </Button>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default FeaturedDeals;
